const sanitize = (value) => value.replace(/(<([^>]+)>)|(alert\(")|("\))/gi, "");
export {
  sanitize
};
//# sourceMappingURL=sanitize.js.map
